import React from 'react';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { getLocalized } from '../../store';

// ОБНОВЛЕНО: Расширен сквозной пул системных идентификаторов материалов каталога
const MATERIALS = [
  'wood', 'mdf', 'chipboard', 'melamine', 'acrylic', 
  'aluminum', 'glass', 'mirror', 'stone', 'natural_veneer', 
  'engineered_veneer', 'hpl', 'leather', 'eco_leather', 
  'fabric', 'primer', 'paint', 'lacquer'
];

const FINISHES = ['matte', 'glossy', 'satin', 'textured', 'natural', 'brushed'];

// ОБНОВЛЕНО: Мультиязычная матрица переводов дополнена меламином, акрилом, ДСП, МДФ и шпоном
const materialTranslations = {
  wood: { en: 'Solid Wood', ru: 'Натуральное Дерево', nl: 'Massief Hout', ro: 'Lemn Masiv' },
  mdf: { en: 'MDF Panels', ru: 'МДФ Панели', nl: 'MDF Panelen', ro: 'Panouri MDF' },
  chipboard: { en: 'Chipboard', ru: 'ДСП / ЛДСП', nl: 'Spaanplaat', ro: 'PAL' },
  melamine: { en: 'Melamine', ru: 'Меламин', nl: 'Melamine', ro: 'Melamină' },
  acrylic: { en: 'Acrylic', ru: 'Акрил', nl: 'Acryl', ro: 'Acrilic' },
  aluminum: { en: 'Aluminum', ru: 'Алюминиевый Профиль', nl: 'Aluminium', ro: 'Aluminiu' },
  glass: { en: 'Premium Glass', ru: 'Премиальное Стекло', nl: 'Premium Glas', ro: 'Sticlă Premium' },
  mirror: { en: 'Mirror', ru: 'Зеркальное Полотно', nl: 'Spiegel', ro: 'Oglindă' },
  stone: { en: 'Natural Stone', ru: 'Натуральный Камень', nl: 'Natuursteen', ro: 'Piatră Naturală' },
  natural_veneer: { en: 'Natural Veneer', ru: 'Натуральный Шпон', nl: 'Natuurlijk Fineer', ro: 'Furnir Natural' },
  engineered_veneer: { en: 'Modified Veneer', ru: 'Модифицированный Шпон', nl: 'Gemodificeerd Fineer', ro: 'Furnir Modificat' },
  hpl: { en: 'HPL Panels', ru: 'HPL Панели', nl: 'HPL Panelen', ro: 'Panouri HPL' },
  leather: { en: 'Natural Leather', ru: 'Натуральная Кожа', nl: 'Natuurlijk Leer', ro: 'Piele Naturală' },
  eco_leather: { en: 'Eco Leather', ru: 'Экокожа', nl: 'Eco-leer', ro: 'Piele Ecologică' },
  fabric: { en: 'Fabric / Textiles', ru: 'Интерьерный Текстиль', nl: 'Stof / Textiel', ro: 'Material / Textile' },
  primer: { en: 'Architectural Primer', ru: 'Архитектурный Грунт', nl: 'Primer', ro: 'Grund' },
  paint: { en: 'Polyurethane Paint', ru: 'Полиуретановая Эмаль', nl: 'Polyurethaanlak', ro: 'Vopsea Poliuretanică' },
  lacquer: { en: 'Protective Lacquer', ru: 'Защитный Лак', nl: 'Beschermende Lak', ro: 'Lac Protecție' }
};

const finishTranslations = {
  matte: { en: 'Matte', ru: 'Матовая', nl: 'Mat', ro: 'Mată' },
  glossy: { en: 'Glossy', ru: 'Глянцевая', nl: 'Glanzend', ro: 'Lucioasă' },
  satin: { en: 'Satin', ru: 'Сатинированная', nl: 'Satijn', ro: 'Satinată' },
  textured: { en: 'Textured', ru: 'Текстурированная', nl: 'Getextureerd', ro: 'Texturată' },
  natural: { en: 'Natural', ru: 'Натуральная фактура', nl: 'Natuurlijk', ro: 'Naturală' },
  brushed: { en: 'Brushed', ru: 'Брашированная', nl: 'Geborsteld', ro: 'Satinat' }
};

const clearActionTranslations = {
  en: 'Clear All Filters',
  ru: 'Сбросить все фильтры',
  nl: 'Alle filters wissen',
  ro: 'Șterge toate filtrele'
};

export const ProductFilters = ({
  categories,
  doorSubcategories,
  selectedCategory,
  selectedSubcategory,
  selectedMaterials,
  selectedFinishes,
  language,
  labels,
  hasActiveFilters,
  onCategoryChange,
  onSubcategoryChange,
  onMaterialsChange,
  onFinishesChange,
  onClear,
}) => (
  <div className="space-y-8">
    {/* Categories */}
    <div>
      <h4 className="text-caption mb-4">{labels.category}</h4>
      <div className="space-y-3">
        {categories.map((cat) => (
          <label key={cat.id} className="flex items-center gap-3 cursor-pointer select-none">
            <Checkbox
              checked={selectedCategory === cat.id}
              onCheckedChange={(checked) => onCategoryChange(checked ? cat.id : '')}
              data-testid={`filter-category-${cat.id}`}
            />
            <span className="text-sm font-light text-gray-900">{getLocalized(cat.name, language)}</span>
          </label>
        ))}
      </div>
    </div>

    {/* Door Subcategories */}
    {selectedCategory === 'doors' && doorSubcategories.length > 0 && (
      <div className="animate-in fade-in slide-in-from-top-1 duration-300">
        <h4 className="text-caption mb-4">{labels.subcategory}</h4>
        <div className="space-y-3">
          {doorSubcategories.map((sub) => (
            <label key={sub.id} className="flex items-center gap-3 cursor-pointer select-none">
              <Checkbox
                checked={selectedSubcategory === sub.id}
                onCheckedChange={(checked) => onSubcategoryChange(checked ? sub.id : '')}
                data-testid={`filter-subcategory-${sub.id}`}
              />
              <span className="text-sm font-light text-gray-900">{getLocalized(sub.name, language)}</span>
            </label>
          ))}
        </div>
      </div>
    )}

    {/* Materials */}
    <div>
      <h4 className="text-caption mb-4">{labels.material}</h4>
      <div className="space-y-3 max-h-64 overflow-y-auto pr-1">
        {MATERIALS.map((material) => (
          <label key={material} className="flex items-center gap-3 cursor-pointer select-none">
            <Checkbox
              checked={selectedMaterials.includes(material)}
              onCheckedChange={(checked) => {
                onMaterialsChange((prev) => (checked ? [...prev, material] : prev.filter((m) => m !== material)));
              }}
              data-testid={`filter-material-${material}`}
            />
            <span className="text-sm font-light text-gray-900">
              {materialTranslations[material]?.[language] || material}
            </span>
          </label>
        ))}
      </div>
    </div>

    {/* Finishes */}
    <div>
      <h4 className="text-caption mb-4">{labels.finish}</h4>
      <div className="space-y-3">
        {FINISHES.map((finish) => (
          <label key={finish} className="flex items-center gap-3 cursor-pointer select-none">
            <Checkbox
              checked={selectedFinishes.includes(finish)}
              onCheckedChange={(checked) => {
                onFinishesChange((prev) => (checked ? [...prev, finish] : prev.filter((f) => f !== finish)));
              }}
              data-testid={`filter-finish-${finish}`}
            />
            <span className="text-sm font-light text-gray-900">
              {finishTranslations[finish]?.[language] || finish}
            </span>
          </label>
        ))}
      </div>
    </div>

    {hasActiveFilters && (
      <Button variant="outline" onClick={onClear} className="w-full rounded-none border-gray-200 text-xs font-normal" data-testid="clear-filters">
        {labels.clearAll && labels.clearAll !== 'Clear All Filters' 
          ? labels.clearAll 
          : (clearActionTranslations[language] || 'Clear All Filters')}
      </Button>
    )}
  </div>
);

export default ProductFilters;
